import { SvgIcon } from '@bob/library'
import { useLocale } from '@websrc/App/Hooks/useLocale'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import clsx from 'clsx'
import { button, styles, typography } from 'leds'
import React from 'react'

import { quantityButton } from './ProductInfoQuantity.style'

export interface ProductInfoQuantityProps {
  quantity: number
  setQuantity: (quantity: number) => void
  show: boolean
}

export const ProductInfoQuantity = ({ quantity, setQuantity, show }: ProductInfoQuantityProps) => {
  const t = useStaticText()
  const locale = useLocale()

  if (locale !== 'en-us' || !show) {
    return null
  }

  return (
    <div className={styles({ display: 'flex', alignItems: 'center', marginRight: 16 })}>
      <button
        aria-label={'Decrease quantity'}
        className={clsx(
          styles({
            openBorderRight: 1,
            borderRightWidth: 0,
          }),
          quantityButton,
          button({ type: 'icon' })
        )}
        onClick={() => setQuantity(Math.max(quantity - 1, 1))}
      >
        <SvgIcon name={'MINUS'} size={14} strokeWidth={5} />
      </button>
      <input
        aria-label={t.ecom.quantity}
        className={clsx(
          styles({
            textAlign: 'center',
            borderWidth: 1,
          }),
          quantityButton,
          typography({ size: 'xl2' })
        )}
        data-testid={'quantity-input'}
        onChange={(e) => {
          // Only update when writing numbers...
          // eslint-disable-next-line @typescript-eslint/prefer-regexp-exec
          if (e.target.value.match(/^[0-9]+$/u) || e.target.value === '') {
            setQuantity(parseInt(e.target.value) || 0)
          }
        }}
        pattern={'[0-9]*'}
        type={'text'}
        value={`${quantity}`}
      />
      <button
        aria-label={'Increase quantity'}
        className={clsx(
          styles({
            openBorderLeft: 1,
            borderLeftWidth: 0,
          }),
          quantityButton,
          button({ type: 'icon' })
        )}
        onClick={() => setQuantity(quantity + 1)}
      >
        <SvgIcon name={'PLUS'} size={14} strokeWidth={5} />
      </button>
    </div>
  )
}
